//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {};
  },
  props: {
    data: {
      required: true,
    },
    cta: {
      required: true,
    },
  },
  computed: {},
  methods: {},
};
